import { CALLING_CODE_ACTION_TYPE } from "./calling-code.action";

export const CALLING_CODE_MESSAGE_CONTEXT = {
	getAll: CALLING_CODE_ACTION_TYPE.getAll,
};
